export default __webpack_public_path__ + "static/media/error404.29be77fc.png";